let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8fhwO")).then(() => parcelRequire('5pMQO'));